import React, { useCallback, useEffect, useRef } from 'react'
import { Search } from '@components/Search'
import { useDebounce } from 'hooks/useDebounce'
import { useDevice } from 'hooks/useDevice'

import { useGiphySearchContext } from './GiphySearchContext'

export const GiphySearchBar = React.memo(() => {
    const { isTouch } = useDevice()
    const { setQuery, setIsFetching, inputValue, setInputValue } = useGiphySearchContext()
    const debouncedValue = useDebounce<string>(inputValue, 500)
    const ref = useRef<HTMLInputElement>(null)

    const onChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setInputValue(e.target.value)
        },
        [setInputValue],
    )

    const onClearClick = useCallback(() => {
        setIsFetching(true)
        setInputValue('')
    }, [setIsFetching, setInputValue])

    useEffect(() => {
        setIsFetching(true)
        setQuery(debouncedValue)
    }, [debouncedValue, setQuery, setIsFetching])

    useEffect(() => {
        if (!isTouch && ref.current) {
            // Small timeout to ensure the DOM is fully ready
            const timeoutId = setTimeout(() => {
                ref.current?.focus()
            }, 50)
            return () => clearTimeout(timeoutId)
        }
    }, [isTouch])

    return (
        <Search
            width="100%"
            ref={ref}
            value={inputValue}
            autoFocus={!isTouch}
            placeholder="Search Giphy"
            onClearClick={onClearClick}
            onChange={onChange}
        />
    )
})

GiphySearchBar.displayName = 'GiphySearchBar'
